const state = {
    openStatus: null,
    deviceUid: '',
};

export default state;